<template>
	<div class="container">
		<div class="mask" @click="closeRules" @touchmove.stop.prevent="moveHandle" v-if="showRule"></div>
		<div class="rule-module" v-if="showRule">
			<div class="title">请微信扫码体验</div>
			<div class="content">
				<img :src="qrcode" mode="aspectFill" />
			</div>
			<!-- <button type="primary" @click="save">保存到相册</button> -->
			<div class="tips">长按二维码保存图片</div>
			<div class="d">{{title}}</div>
			<div class="close-icon" @click="closeRules"></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			showRule: {
				type: Boolean,
				require: true,
				default: false
			},
			qrcode: {
				type: String,
			},
			title: String
		},
		data(){
			return {
				
			}
		},
		methods: {
			moveHandle(){
				return
			},
			// 关闭弹窗
			closeRules(){
				// this.showRule = false
				this.$emit('close',false)
				
			},
			// h5 保存图片
			save(){
				this.downloadIamge(this.qrcode,'qrcode')
			},
			downloadIamge(imgsrc, name) {//下载图片地址和图片名
                var image = new Image()
                // 解决跨域 Canvas 污染问题
                image.setAttribute('crossOrigin', 'anonymous')
                image.onload = function() {
                var canvas = document.createElement('canvas')
                canvas.width = image.width
                canvas.height = image.height
                var context = canvas.getContext('2d')
                context.drawImage(image, 0, 0, image.width, image.height)
                var url = canvas.toDataURL('image/png') //得到图片的base64编码数据
                // console.log('****url',url)
                var a = document.createElement('a') // 生成一个a元素
                var event = new MouseEvent('click') // 创建一个单击事件
                a.download = name || 'photo' // 设置图片名称
                a.href = url // 将生成的URL设置为a.href属性
                a.dispatchEvent(event) // 触发a的单击事件
                }
                image.src = imgsrc
			},
		}
	}
</script>

<style lang="scss" scoped>
	.mask{
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.5);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
        opacity: 1;
	}
	.rule-module{
		width: 5.10rem;
		border-radius: .20rem;
		background: #fff;
		padding: .30rem;
		position: fixed;
		top: 50%;
		left: 0;
		right: 0;
		margin: auto;
		animation: zoomIn 0.5s;
		z-index: 10000;
        transform: translate(0, -50%);
		.title{
			font-size: .32rem;
			color: #333;
			text-align: center;
			margin-bottom: .20rem;
		}
		.content{
			color: #666;
			font-size: .28rem;
			text-align: center;
			img{
				width: 4.00rem;
				height: 4.00rem;
			}
		}
		.tips {
			font-size: .28rem;
			margin-top: .20rem;
			color: #666;
			text-align: center;
		}
		.close-icon{
			position: absolute;
			bottom: -.80rem;
			right: 0;
			left: 0;
			margin: auto;
		}
	}
</style>
